import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import { ServedItemAccessFieldEnum as Fields } from 'Common/FieldEnum';
import { ASSIGN_SITES_TO_SERVED_ITEM_FORM_NAME } from 'Common/FormEnum';
import SelectSitesTable from 'Common/SelectSitesTableReduxForm';

class AssignSitesToServedItem extends Component {
  static props = {
    loading: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <React.Fragment>
        <Field
          name={Fields.SiteIds}
          component={SelectSitesTable}
          isPrimary={true}
          loading={this.props.loading}
        />
      </React.Fragment>
    );
  }
}

export const AssignSitesToServedItemForm = reduxForm({
  form: ASSIGN_SITES_TO_SERVED_ITEM_FORM_NAME,
  enableReinitialize: true,
})(withRouter(AssignSitesToServedItem));



// WEBPACK FOOTER //
// ./src/pages/serveditemaccesssetup/components/AssignSitesToServedItemForm.js